import { App, Component, DefineComponent, VNode, createApp, h, watch } from 'vue'

type Content = ReturnType<typeof h>
interface UseComponentConfig<T = any> {
  component: VNode | Component | Content | DefineComponent
  props?: T
  id?: string | number
  [property: string]: any
}

const popup: Record<number | string, () => void> = {}

export const usePopup = (config: UseComponentConfig) => {
  const { component, props, id: customId } = config
  const div = document.createElement('div')

  // 如果没有传入id，则生成一个
  const popupId = customId !== undefined ? customId : guid()

  /**
   * 展示组件
   * @param app 组件实例
   * @param param1
   */
  const mountComponent = (
    app: App,
    { resolve, reject }: { resolve: Function; reject: Function },
  ) => {
    // 创建文档碎片
    document.body.appendChild(div)
    // 将组件挂载在文档碎片上
    const vm = app.mount(div) as any
    // 组件显示
    vm.setVisible(true)

    popup[popupId] = () => {
      app && unmountComponent(app)
    }

    watch(vm.state, (state) => {
      if (!state.isVisible) {
        switch (state.type) {
          case 'confirm':
            resolve()
            break
          case 'cancel':
            reject()
            break
        }
        delete popup[popupId]
        setTimeout(() => {
          unmountComponent(app)
        }, 300)
      }
    })
  }

  /**
   * 卸载组件
   * @param app 组件实例
   */
  const unmountComponent = (app: App) => {
    app.unmount()
    if (div.parentNode) {
      document.body.removeChild(div)
    }
  }

  const componentInstance = createApp(component, {
    ...props,
  })

  return new Promise((resolve, reject) => {
    mountComponent(componentInstance, { resolve, reject })
  })
}

export const closeAllPopup = () => {
  for (const key in popup) {
    popup[key]()
    delete popup[key]
  }
}

export const closePopupById = (id: string | number) => {
  if (popup[id]) {
    popup[id]()
    delete popup[id]
  }
}
